import { gql } from "@apollo/client";

export const DELETE_PACKAGE_ORDER_BY_PK = gql`
  mutation deleteOrderByPk($id: Int!) {
    delete_package_order_by_pk(id: $id) {
      id
    }
  }
`;
